// cspell:words thefwa

import { type ImportableBrands, type KnownBrands } from './types.js';

export const brands: KnownBrands = {
  ANGELLIST: { domain: 'angel.co', name: 'AngelList' },
  ARTSTATION: { domain: 'artstation.com', name: 'ArtStation' },
  AWWWARDS: { domain: 'awwwards.com', name: 'Awwwards' },
  BEHANCE: { domain: 'behance.net', name: 'Behance' },
  CARBONMADE: {
    domain: ['carbonmade.com', 'portfolio.site'],
    name: 'Carbonmade',
  },
  DEV: { domain: 'dev.to', name: 'DEV' },
  DEVIANTART: { domain: 'deviantart.com', name: 'DeviantArt' },
  DRIBBBLE: { domain: 'dribbble.com', name: 'Dribbble' },
  FACEBOOK: { domain: 'facebook.com', name: 'Facebook' },
  FIVERR: { domain: 'fiverr.com', name: 'Fiverr' },
  FREELANCER: { domain: 'freelancer.com', name: 'Freelancer' },
  FWA: { domain: 'thefwa.com', name: 'The FWA' },
  GITHUB: { domain: 'github.com', name: 'GitHub' },
  GITLAB: { domain: 'gitlab.com', name: 'GitLab' },
  HASHNODE: { domain: 'hashnode.com', name: 'Hashnode' },
  INSTAGRAM: { domain: 'instagram.com', name: 'Instagram' },
  LINKEDIN: { domain: 'linkedin.com', name: 'LinkedIn' },
  MEDIUM: { domain: 'medium.com', name: 'Medium' },
  PATREON: { domain: 'patreon.com', name: 'Patreon' },
  PINTEREST: { domain: 'pinterest.com', name: 'Pinterest' },
  SOUNDCLOUD: { domain: 'soundcloud.com', name: 'SoundCloud' },
  STACKOVERFLOW: { domain: 'stackoverflow.com', name: 'Stack Overflow' },
  TIKTOK: { domain: 'tiktok.com', name: 'TikTok' },
  TUMBLR: { domain: 'tumblr.com', name: 'Tumblr' },
  TWITCH: { domain: 'twitch.tv', name: 'Twitch' },
  TWITTER: { domain: 'twitter.com', name: 'Twitter' },
  UPWORK: { domain: 'upwork.com', name: 'Upwork' },
  VIMEO: { domain: 'vimeo.com', name: 'Vimeo' },
  VKONTAKTE: { domain: 'vk.com', name: 'VK' },
  WNW: { domain: 'workingnotworking.com', name: 'WNW' },
  // eslint-disable-next-line id-length
  X: { domain: 'x.com', name: 'X' },
  YOUTUBE: { domain: 'youtube.com', name: 'YouTube' },
};

export const importableBrands: ImportableBrands = {
  BEHANCE: brands.BEHANCE,
  DEV: brands.DEV,
  FACEBOOK: brands.FACEBOOK,
  GITHUB: brands.GITHUB,
  INSTAGRAM: brands.INSTAGRAM,
  LINKEDIN: brands.LINKEDIN,
  MEDIUM: brands.MEDIUM,
  PINTEREST: brands.PINTEREST,
  SOUNDCLOUD: brands.SOUNDCLOUD,
  TIKTOK: brands.TIKTOK,
  TWITTER: brands.TWITTER,
  VIMEO: brands.VIMEO,
  // eslint-disable-next-line id-length
  X: brands.X,
  YOUTUBE: brands.YOUTUBE,
};
